<template>
  <div class="real-time-intercom overFlowXauto">
    <div class="normal" v-if="isNormal">
      <div class="real-left" :style="{ height: clientHeight }">
        <div class="cut">
          <span
            class="nape"
            :class="{ isActive: deleted === false }"
            @click="cutPath(false)"
          >
            实时对讲 <el-divider direction="vertical"></el-divider
          ></span>
          <span
            class="nape"
            :class="{ isActive: deleted === true }"
            @click="cutPath(true)"
          >
            历史对讲
          </span>
        </div>
        <el-button
          v-if="!deleted"
          type="primary"
          @click="addQuick"
          style="width: 100%; margin-top: 15px"
          plain
          ><i class="el-icon-plus"></i> 快速添加
        </el-button>
        <el-date-picker
          style="margin: 10px 3px; width: 100%"
          @change="chooseDate(deleted, 2, dateTime)"
          v-if="deleted === true"
          v-model="dateTime"
          type="date"
          placeholder="选择会议日期日期"
        >
        </el-date-picker>
        <div class="groupBox" v-if="groupList">
          <div
            class="group pointer"
            @click="enterChat(group, inx)"
            v-for="(group, inx) in groupList"
            :class="{ 'is-group': group.id == SelectGroupId ? true : false }"
            :key="inx"
          >
            {{ group.groupName }}
          </div>
        </div>
        <div class="">
          <i></i>
        </div>
      </div>
      <div class="real-right" :style="{ height: clientHeight }" v-if="SelectGroupId">
        <div class="button-box" v-if="deleted === false">
          <el-button
            type="danger"
            v-if="meetingDetails.creator == userId"
            @click="overGroup"
            >结束会议</el-button
          >
          <el-button
            type="warning"
            v-if="meetingDetails.creator != userId"
            @click="quitGroup"
            >退出会议</el-button
          >
        </div>
        <div :class="deleted === false ? 'real-box' : 'real-box no-btn'">
          <div class="webSockBOX">
            <webSock
              :textTitle="textTitle"
              :createTime="meetingDetails.meetingTime"
              :groupId="SelectGroupId"
              :disabled="deleted === true"
              ref="webSock"
            ></webSock>
          </div>
          <div class="groupMembers">
            <div class="weui-div" @click.stop="toggle">
              <span
                class="weui-switch"
                :class="{ 'weui-switch-on': switchValue }"
                :value="switchValue"
              ></span>
              <div
                class="weui-div-1 weui-div-box"
                :style="{
                  color: !switchValue ? '#fff' : '#000',
                  opacity: switchValue ? 0.3 : 1,
                }"
              >
                会议信息
              </div>
              <div
                class="weui-div-2 weui-div-box"
                :style="{
                  color: switchValue ? '#fff' : '#000',
                  opacity: !switchValue ? 0.3 : 1,
                }"
              >
                成员列表
              </div>
            </div>
            <div class="switchValue" v-if="switchValue">
              <div class="addMembers pointer" v-if="deleted === false" @click="addUser">
                <i class="el-icon-plus"></i> 添加群员
              </div>
              <div class="groupMembers-list">
                <div class="members" v-for="item in meetingPersonnelList" :key="item.id">
                  <!--                                    判断是否在线 online -->
                  <img
                    class="headPortrait"
                    v-if="!item.type"
                    height="60"
                    width="60"
                    :style="{ opacity: item.online ? '1' : '0.5' }"
                    :src="
                      item.portrait && item.portrait != null
                        ? item.portrait
                        : require('./../../../../assets/images/command-center/user-icon.png')
                    "
                  />
                  <img
                    class="headPortrait"
                    v-else
                    height="60"
                    width="60"
                    :style="{ opacity: item.online ? '1' : '0.5' }"
                    :src="
                      require('./../../../../assets/images/command-center/camera.png')
                    "
                  />
                  <div
                    class="members-info"
                    :style="{ opacity: item.online ? '1' : '0.5' }"
                  >
                    <p class="ellipsis" :title="item.realName">
                      名称:{{ item.realName }}
                    </p>
                    <p class="ellipsis" v-if="!item.type" :title="item.phone">
                      手机号:{{ item.phone }}
                    </p>
                    <p class="ellipsis" :title="item.areaName">
                      区域:{{ item.areaName }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="groupInfo" v-else>
              <div class="nape">
                <p class="title">会议号：</p>
                <p class="content space-between">
                  <span id="meeting">{{ meetingDetails.id }}</span>
                  <el-button
                    :disabled="deleted"
                    type="primary"
                    size="mini"
                    style="margin-top: -5px"
                    @click="copy"
                    >复制</el-button
                  >
                </p>
              </div>
              <div class="nape">
                <p class="title">主持人：</p>
                <p class="content">{{ meetingDetails.hostUser || "暂无" }}</p>
              </div>
              <div class="nape">
                <p class="title">主持单位：</p>
                <p class="content">{{ meetingDetails.hostUnit || "暂无" }}</p>
              </div>
              <div class="nape">
                <p class="title">会议时间：</p>
                <p class="content">{{ meetingDetails.meetingTime || "暂无" }}</p>
              </div>
              <div class="nape">
                <p class="title">会议概要：</p>
                <p class="content" style="font-weight: normal">
                  {{ meetingDetails.content }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="null-vision">
        <i class="iconfont iconkafei"></i>
        <span>暂无会议</span>
        <span>暂时没有进行中的会议，快去创建一个吧</span>
        <span class="add-vision" @click="addQuick" v-if="deleted == false">
          <el-button type="primary" style="width: 100%; margin-top: 15px" plain
            ><i class="el-icon-plus"></i> 快速添加
          </el-button>
        </span>
      </div>
    </div>
    <div class="addGroup" v-else :style="{ height: clientHeight }">
      <div class="addGroup-BG">
        <div
          class="module pointer"
          @click="moduleClick(i + 1)"
          :key="i"
          v-for="(item, i) in moduleLits"
        >
          <i
            class="module-left iconfont"
            :style="{ color: item.color }"
            :class="item.src"
          ></i>
          <div class="module-right">
            <p class="title">{{ item.title }}</p>
            <p class="remark">{{ item.remark }}</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      top="5vh"
      :title="groupUserDto.meetingLevel == 1 ? '添加紧急会议' : '添加预约会议'"
      :visible.sync="dialogVisible"
      width="1300px"
      :before-close="handleClose"
      custom-class="add-Meeting"
    >
      <!-- <div style="height: 100%; overflow-y: auto"> -->
        <el-form
          :model="groupUserDto"
          :rules="rules"
          ref="groupUserDto"
          label-width="100px"
          size="mini"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="会议名称" prop="groupName">
                <el-input
                  placeholder="请输入会议名称"
                  v-model="groupUserDto.groupName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会议主持人" prop="hostUser">
                <el-input
                  placeholder="请输入会议主持人"
                  v-model="groupUserDto.hostUser"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="groupUserDto.meetingLevel == 1">
            <el-col :span="12">
              <el-form-item label="会议时间" prop="startTime">
                <el-date-picker
                  v-model="groupUserDto.startTime"
                  value-format="timestamp"
                  type="datetime"
                  placeholder="请选择会议时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主持单位" prop="hostUnit">
                <el-input
                  placeholder="请输入主持单位"
                  v-model="groupUserDto.hostUnit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="短信通知" prop="sms">
                <el-radio v-model="groupUserDto.sms" :label="true">是</el-radio>
                <el-radio v-model="groupUserDto.sms" :label="false">否</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="会议内容" prop="content">
                <el-input
                  type="textarea"
                  style="width: 100%"
                  placeholder="请输入会议内容"
                  v-model="groupUserDto.content"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="参会人员" prop="allUser">
            <div class="areaAccredit">
              <!-- 摄像头信息-->
              <el-tag
                v-for="tag in groupUserDto.cameraIds"
                :key="tag.name"
                style="margin-right: 10px; margin-bottom: 10px"
                closable
                @close="closable(groupUserDto.cameraIds, tag)"
                type="warning"
              >
                {{ tag.name }}
              </el-tag>
              <!-- 人员信息-->
              <el-tag
                v-for="tag in groupUserDto.userIds"
                :key="tag.id"
                style="margin-right: 10px; margin-bottom: 10px"
                closable
                @close="closable(groupUserDto.userIds, tag)"
                type="success"
                >{{ tag.realName }}
              </el-tag>
            </div>
            <div class="">
              <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="用户" name="first">
                  <div class="flex-content">
                    <div class="left">
                      <Tree
                        @changeSwitch="changeSwitch"
                        :switchVal="switchVal"
                        @nodeClick="nodeClick"
                      ></Tree>
                    </div>
                    <div class="right">
                      <TabelSearch
                        :searchConfig="searchConfig"
                        :size="'mini'"
                        :searchParams="searchParams"
                        @resetCallBack="resetCallBack"
                        @search="setSearchParams"
                      ></TabelSearch>
                      <Table
                        :width="'100%'"
                        :size="'mini'"
                        :tableLoading="tableLoading"
                        :templateData="tableTemplateData"
                        :tableConfig="tableConfig"
                        :pagination="pagination"
                      >
                      </Table>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="摄像头" name="second">
                  <div class="flex-content">
                    <div class="left">
                      <Tree
                        @changeSwitch="changeSwitch2"
                        :switchVal="switchVal2"
                        @nodeClick="nodeClick2"
                      ></Tree>
                    </div>
                    <div class="right">
                      <TabelSearch
                        :searchConfig="searchConfig2"
                        :size="'mini'"
                        :searchParams="searchParams2"
                        @resetCallBack="resetCallBack2"
                        @search="setSearchParams2"
                      ></TabelSearch>
                      <Table
                        :width="'100%'"
                        :size="'mini'"
                        :tableLoading="tableLoading2"
                        :templateData="tableTemplateData2"
                        :tableConfig="tableConfig2"
                        :pagination="pagination2"
                      >
                      </Table>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-form-item>
        </el-form>
      <!-- </div> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="addMeeting('groupUserDto')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      top="5vh"
      title="添加成员"
      :visible.sync="dialogVisible3"
      width="1200px"
      :before-close="handleClose"
    >
      <el-form
        :model="userDto"
        :rules="rules"
        ref="groupUserDto"
        label-width="100px"
        size="mini"
      >
        <el-form-item label="参会人员">
          <div class="areaAccredit">
            <!-- 摄像头信息-->
            <el-tag
              v-for="tag in userDto.cameraId"
              :key="tag.name"
              style="margin-right: 10px; margin-bottom: 10px"
              closable
              @close="closable(userDto.cameraId, tag)"
              type="warning"
            >
              {{ tag.name }}
            </el-tag>
            <!-- 人员信息-->
            <el-tag
              v-for="tag in userDto.userId"
              :key="tag.id"
              style="margin-right: 10px; margin-bottom: 10px"
              closable
              @close="closable(userDto.userId, tag)"
              type="success"
              >{{ tag.realName }}
            </el-tag>
          </div>
          <div class="">
            <el-tabs type="border-card" v-model="activeName2" @tab-click="handleClick2">
              <el-tab-pane label="用户" name="first">
                <div class="flex-content">
                  <div class="left">
                    <Tree
                      @changeSwitch="changeSwitch3"
                      :switchVal="switchVal3"
                      @nodeClick="nodeClick3"
                    ></Tree>
                  </div>
                  <div class="right" style="height:100%">
                    <TabelSearch
                      :searchConfig="searchConfig3"
                      :size="'mini'"
                      :searchParams="searchParams3"
                      @resetCallBack="resetCallBack3"
                      @search="setSearchParams3"
                    ></TabelSearch>
                    <Table
                      :width="'100%'"
                      :size="'mini'"
                      :tableLoading="tableLoading3"
                      :templateData="tableTemplateData3"
                      :tableConfig="tableConfig3"
                      :pagination="pagination3"
                    >
                    </Table>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="摄像头" name="second">
                <div class="flex-content">
                  <div class="left">
                    <Tree
                      @changeSwitch="changeSwitch4"
                      :switchVal="switchVal4"
                      @nodeClick="nodeClick4"
                    ></Tree>
                  </div>
                  <div class="right">
                    <TabelSearch
                      :searchConfig="searchConfig4"
                      :size="'mini'"
                      :searchParams="searchParams4"
                      @resetCallBack="resetCallBack4"
                      @search="setSearchParams4"
                    ></TabelSearch>
                    <Table
                      :width="'100%'"
                      :size="'mini'"
                      :tableLoading="tableLoading4"
                      :templateData="tableTemplateData4"
                      :tableConfig="tableConfig4"
                      :pagination="pagination4"
                    >
                    </Table>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="addUserMeeting('userDto')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="加入会议"
      :visible.sync="dialogVisible2"
      :before-close="handleClose"
      width="400px"
    >
      <el-form
        :model="groupDto"
        :rules="rules2"
        ref="groupDto"
        label-width="100px"
        size="mini"
      >
        <el-form-item label="会议号" prop="groupId">
          <el-input placeholder="请输入会议号" v-model="groupDto.groupId"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="joinConference(true, 'groupDto')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <input
      style="height: 0px; border: 0; opacity: 0; position: fixed; top: -100px"
      id="input"
    />
  </div>
</template>

<script>
import webSock from "../../../../components/webSock/webSrom";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import publicAPI from "../../../../api-path/public-api";
import { userApi } from "../../../../api-path/user-api";
import { cameraApi } from "../../../../api-path/district-api";
import Tree from "@/components/Tree/meetingNodeTree";
export default {
  name: "real-time-intercom",
  components: {
    webSock,
    TabelSearch,
    Tree,
  },
  data() {
    return {
      showWebSock: false, //会议消息框
      groupId: "", //会议ID
      dateTime: new Date().getTime(),
      deleted: false,
      activeName: "first",
      activeName2: "first",
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false, //添加会议成员
      moduleLits: [
        // {
        //     title:'紧急会议',
        //     remark:'创建一个立即召开的会议',
        //     color:'#ff3b30',
        //     src:'iconjinjihuiyitixing',
        // },
        {
          title: "创建会议",
          remark: "创建一个新的会议",
          color: "#3e80ff",
          src: "iconyuyuehuiyi",
        },
        {
          title: "加入会议",
          remark: "填写会议号加入已创建的会议",
          color: "#41cc8b",
          src: "iconjiaruhuiyi",
        },
        {
          title: "取消添加",
          remark: "取消快速添加,返回页面",
          color: "#666",
          src: "iconquxiaotianjiabeifen",
        },
      ],
      isNormal: true,
      clientHeight: "",
      clientHeight2: "",
      screenHeight: "",
      pathList: [],
      groupList: [], //所有群组
      switchValue: true,
      groupUserDto: {
        cameraIds: [], //群成员id
        userIds: [], //群成员id
        content: "", //音视频聊天 会议内容
        createUser: "", //创建人
        groupName: "", //群名称
        hostUnit: "", //音视频聊天 主持单位
        hostUser: "", //音视频聊天 主持人
        id: "", //指定id（如报警时使用报警事件id）
        meetingLevel: 0, //音视频聊天 会议程度 0 不是会议（普通聊天群） 1 紧急会议 2 预约会议
        startTime: "", //音视频聊天 会议开始事件
        type: 2, //群类型，0，单聊群，1，多人聊天群 2，音视频聊天
        sms: false, //是否发送短信
      },
      //加入会议
      groupDto: {
        groupId: "",
        in: true,
      },
      userDto: {
        userId: [],
        cameraId: [],
      },
      //人员信息
      //表格start
      rules: {
        hostUser: [
          {
            required: true,
            message: "请输入会议主持人",
            trigger: "blur",
          },
        ],
        hostUnit: [
          {
            required: true,
            message: "请输入会议单位",
            trigger: "blur",
          },
        ],
        groupName: [
          {
            required: true,
            message: "请输入会议名称",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请选择会议时间",
            trigger: "change",
          },
        ],
      },
      rules2: {
        groupId: [
          {
            required: true,
            message: "请输入会议号",
            trigger: "blur",
          },
        ],
      },
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "nameOrPhone",
            valueType: "text",
            placeholder: "输入姓名/手机号搜索",
          },
        ],
      },
      searchParams: {
        search: "",
        areaId: "",
        isDown: true,
        areaName: "",
        page: 1,
        size: 6,
        userType: 1,
      },
      tableLoading: false,
      tableTemplateData: [],
      tableConfig: {
        checkbox: false,
        rows: [
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "真实姓名",
            prop: "realName",
          },
          {
            label: "类型",
            prop: "userTypeName",
            width: "120px",
          },
          {
            label: "备注",
            prop: "remark",
            type: "popover",
            width: "120px",
          },
          {
            label: "是否实名认证",
            prop: "isAuthName",
            width: "120px",
          },
        ],
        rowButtons: {
          width: "100px",
          items: [
            {
              label: "加入会议",
              fn: (data) => {
                if (data.id == sessionStorage.getItem("userId")) {
                  this.$message.error("你已会议中，请选择其他成员！");
                } else {
                  this.groupUserDto.userIds.push(data);
                }
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 6,
        pageSizes: [6],
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      }, // 分页
      //新增人员信息
      //-----------------人员信息--------------
      searchConfig3: {
        dataName: "searchParams",
        items: [
          {
            key: "nameOrPhone",
            valueType: "text",
            placeholder: "输入姓名/手机号搜索",
          },
        ],
      },
      searchParams3: {
        search: "",
        areaId: "",
        isDown: true,
        areaName: "",
        page: 1,
        size: 6,
        userType: 1,
      },
      tableLoading3: false,
      tableTemplateData3: [],
      tableConfig3: {
        checkbox: false,
        rows: [
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "真实姓名",
            prop: "realName",
          },
          {
            label: "类型",
            prop: "userTypeName",
            width: "120px",
          },
          {
            label: "备注",
            prop: "remark",
            type: "popover",
            width: "120px",
          },
          {
            label: "是否实名认证",
            prop: "isAuthName",
            width: "120px",
          },
        ],
        rowButtons: {
          width: "100px",
          items: [
            {
              label: "加入会议",
              fn: (data) => {
                this.userDto.userId.push(data);
              },
            },
          ],
        },
      },
      pagination3: {
        show: true,
        total: 0,
        page: 1,
        size: 6,
        pageSizes: [6],
        sizeChange: this.sizeChange3,
        pageChange: this.pageChange3,
      }, // 分页
      //-----------------摄像头--------------------
      searchParams4: {
        areaId: "",
        monitorType: "", //监控类型
        search: "", //关键词
        type: "", //区域类型  1 公共摄像头 2 区域公共 3 私家
        isDown: true,
        page: 1,
        size: 6,
      },
      searchConfig4: {
        dataName: "searchParams",
        items: [
          {
            key: "type",
            valueType: "select",
            placeholder: "选择划分类型",
            option: {
              label: "name",
              value: "id",
            },
            data: [
              {
                name: "公共",
                value: 1,
              },
              {
                name: "区域公共",
                value: 2,
              },
              {
                name: "个人",
                value: 3,
              },
            ],
          },
          // {
          // 	key: 'monitorType',
          // 	valueType: 'select',
          // 	placeholder: '请选择监控类型',
          // 	option: {
          // 		label: 'name',
          // 		value: 'value'
          // 	},
          // 	data: [{
          // 		name: '雪亮监控',
          // 		value: 1
          // 	}, {
          // 		name: '社会监控',
          // 		value: 2
          // 	}],
          // },
          {
            key: "search",
            valueType: "text",
            placeholder: "请输入关键词",
          },
        ],
      },
      //表格
      tableLoading4: false,
      tableTemplateData4: [],
      tableConfig4: {
        checkbox: false,
        checkboxFn: (data) => {},
        height: "100%",
        rows: [
          {
            label: "名称",
            prop: "name",
          },
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "地址",
            prop: "address",
          },
        ],
        rowButtons: {
          width: "100px",
          items: [
            {
              label: "加入会议",
              fn: (data) => {
                let arr = this.groupList.filter((item) => {
                  return item.id == data.id;
                });
                let arr2 = this.meetingPersonnelList.filter((item) => {
                  return item.id == data.id;
                });
                if (arr.length == 0 && arr2.length == 0) {
                  this.userDto.cameraId.push(data);
                } else {
                  this.$message.error("已在会议中，无需再添加");
                }
              },
            },
          ],
        },
      },
      pagination4: {
        show: true,
        total: 0,
        page: 1,
        size: 6,
        pageSizes: [6],
        sizeChange: this.sizeChange4,
        pageChange: this.pageChange4,
      }, // 分页
      //摄像头信息
      searchParams2: {
        areaId: "",
        monitorType: "", //监控类型
        search: "", //关键词
        type: "", //区域类型  1 公共摄像头 2 区域公共 3 私家
        isDown: true,
        page: 1,
        size: 6,
      },
      searchConfig2: {
        dataName: "searchParams",
        items: [
          {
            key: "type",
            valueType: "select",
            placeholder: "选择划分类型",
            option: {
              label: "name",
              value: "id",
            },
            data: [
              {
                name: "公共",
                value: 1,
              },
              {
                name: "区域公共",
                value: 2,
              },
              {
                name: "个人",
                value: 3,
              },
            ],
          },
          // {
          // 	key: 'monitorType',
          // 	valueType: 'select',
          // 	placeholder: '请选择监控类型',
          // 	option: {
          // 		label: 'name',
          // 		value: 'value'
          // 	},
          // 	data: [{
          // 		name: '雪亮监控',
          // 		value: 1
          // 	}, {
          // 		name: '社会监控',
          // 		value: 2
          // 	}],
          // },
          {
            key: "search",
            valueType: "text",
            placeholder: "请输入关键词",
          },
        ],
      },
      //表格
      tableLoading2: false,
      tableTemplateData2: [],

      tableConfig2: {
        checkbox: false,
        checkboxFn: (data) => {
          console.log(data);
		},
		height:'100%',
        rows: [
          {
            label: "名称",
            prop: "name",
          },
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "地址",
            prop: "address",
          },
        ],
        rowButtons: {
          width: "100px",
          items: [
            {
              label: "加入会议",
              fn: (data) => {
                this.groupUserDto.cameraIds.push(data);
              },
            },
          ],
        },
      },
      pagination2: {
        show: true,
        total: 0,
        page: 1,
        size: 6,
        pageSizes: [6],
        sizeChange: this.sizeChange2,
        pageChange: this.pageChange2,
      }, // 分页
      // 会议信息
      meetingPersonnelList: [], //会员成员
      meetingDetails: {}, //会议详情
      creator: "", //群组
      userId: JSON.parse(localStorage.getItem("ur")).id, //本人ID
      //增补
      switchVal: true,
      switchVal2: true,
      switchVal3: true,
      switchVal4: true,
      SelectGroupId: sessionStorage.getItem("meetingId"), //当前正在聊天的会议
      textTitle:'',//当前会议标题
    };
  },
  computed: {
    meetingId() {
      return this.$store.state.meetingId;
    },
    currentMeetingInfo() {
      return this.$store.state.currentMeetingInfo;
    },
  },
  watch: {
    meetingId(newVal, oldVal) {
      this.SelectGroupId = newVal;
      this.deleted = false;
      this.getListData();
    },
    currentMeetingInfo(newVal, oldVal) {
      const $this = this;
      if (newVal.groupId) {
        if (newVal.groupId === this.SelectGroupId && newVal.groupType == 1) {
          this.$alert("当前会议已经结束了哦！", "会议结束", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.SelectGroupId = "";
              this.getListData();
            },
          });
        } else if (newVal.groupId === this.SelectGroupId && newVal.groupType == 2) {
          //有人加入
          this.meetingInfo(newVal.groupId);
        } else if (newVal.groupId === this.SelectGroupId && newVal.groupType == 3) {
          //移除
          this.meetingInfo(newVal.groupId);
        } else {
          // $this.$notify({
          //   title: "会议提示",
          //   message: "《" + newVal.groupName + "》" + "会议已结束！",
          // });
          this.getListData();
        }
        this.$store.commit("setCurrentMeetingInfo", {});
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem("deleted");
    next();
  },
  mounted() {
    var _this = this;
    window.onresize = function () {
      // 定义窗口大小变更通知事件
      _this.clientHeight = document.body.clientHeight - 120 + "px";
      _this.screenHeight = window.screen.height - 60 + "px";
      _this.clientHeight2 = document.body.clientHeight - 375;
    };
  },
  created() {
    this.clientHeight = document.body.clientHeight - 120 + "px";
    this.screenHeight = window.screen.height - 60 + "px";
    this.clientHeight2 = document.body.clientHeight - 375;
    // if(sessionStorage.getItem('meetingId')){
      this.SelectGroupId = sessionStorage.getItem("meetingId");
      this.searchMeetingList(this.deleted, 2);
    // }
  },
  beforeDestroy() {
    if (this.deleted) {
      this.$store.commit("setMeetingId", "");
      sessionStorage.setItem("meetingId", "");
    }
  },
  methods: {
    //选择日期
    chooseDate(deleted, type, dateTime) {
      this.SelectGroupId = "";
      this.getListData();
    },
    //判断请求
    getListData() {
      if (this.deleted) {
        //历史
        this.searchMeetingList(true, 2, this.dateTime);
      } else {
        //实时
        this.searchMeetingList(false, 2);
      }
    },
    searchMeetingList(deleted, types, dateTime) {
      //查询会议列表
      let params = {
        dateTime: dateTime ? new Date(dateTime).getTime() : "",
        deleted: deleted,
        types: [types],
      };
      this.$http.post(publicAPI.userGroupList, params).then((res) => {
        if (res.status == 200) {
          this.groupList = res.result;
          if (res.result && res.result.length > 0) {
            if (this.SelectGroupId) {
              //判断是否有正在处理的会议
              let arr = res.result.filter((item) => {
                return item.id == this.SelectGroupId;
              });
              this.meetingDetails = arr[0];
              this.meetingInfo(this.SelectGroupId); //获取会议成员信息
            } else {
              this.SelectGroupId = res.result[0].id;
              this.meetingDetails = res.result[0];
              this.meetingInfo(this.SelectGroupId);
            }
            res.result.map((item) => {
              if (item.id == this.SelectGroupId) {
                this.textTitle = item.groupName;
              }
            });
          }
        }
      });
    },
    searchSelfGroup() {
      //根据Id创建的群
      let params = {
        userId: sessionStorage.getItem("userId"),
      };
      this.$http
        .get(publicAPI.userGroupList, {
          params: params,
        })
        .then((res) => {
          if (res.status == 200) {
            this.searchAddGroup(res.data.data);
          }
        });
    },
    searchAddGroup(list) {
      //根据Id加入的群
      let params = {
        userId: sessionStorage.getItem("userId"),
      };
      this.$http
        .get(publicAPI.searchAddGroup, {
          params: params,
        })
        .then((res) => {
          if (res.code == 200) {
            let obj = {};
            let data = [...list, ...res.data.data];
            let peon = data.reduce((cur, next) => {
              obj[next.id] ? "" : (obj[next.id] = true && cur.push(next));
              return cur;
            }, []); //设置cur默认类型为数组，并且初始值为空的数组
            this.groupList = peon;
            this.SelectGroupId = this.groupList[0].id;
          }
        });
    },
    overGroup() {
      //解散会议 结束会议
      this.$confirm("确定结束会议?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let groupDto = {
            groupId: this.SelectGroupId,
            in: false,
          };
          this.$http.post(publicAPI.concludeMeeting, groupDto).then((res) => {
            if (res.status == 200) {
              this.$message.success("会议结束成功");
              this.SelectGroupId = "";
              this.getListData();
              // this.searchMeetingList(this.deleted,2);
            }
          });
        })
        .catch(() => {});
    },
    quitGroup() {
      // 退出会议 退出群聊
      this.$confirm("确定退出会议?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let groupDto = {
            in: false,
            groupId: this.SelectGroupId,
            userId: sessionStorage.getItem("userId"),
            type: false,
          };
          this.addOrRemoveMeeting(groupDto, false);
        })
        .catch(() => {});
    },
    cutPath(isTrue) {
      sessionStorage.setItem("deleted", isTrue);
      this.deleted = isTrue;
      this.SelectGroupId = "";
      this.getListData();
    },
    toggle() {
      this.switchValue = !this.switchValue;
    },
    enterChat(item, index) {
      //选择会议群
      // this.$refs.webSock.ClearChatLogs();
      this.SelectGroupId = item.id;
      this.meetingDetails = this.groupList[index];
      this.textTitle = this.meetingDetails.groupName;
      this.meetingInfo(item.id);
    },

    meetingInfo(id) {
      //会议成员信息
      this.$http
        .get(publicAPI.groupUserInfo, {
          params: {
            groupId: id,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.meetingPersonnelList = res.result;
          }
        });
    },
    addQuick() {
      this.isNormal = !this.isNormal;
    },
    moduleClick(inx) {
      const newUr = localStorage.getItem("p");
      switch (inx) {
        // case 1: //
        //     this.groupUserDto.hostUser=newUr?newUr:'';
        //     this.groupUserDto.meetingLevel=1
        //    this.dialogVisible=true;
        //     this.startSearch()
        //     break;
        case 1:
          this.groupUserDto.hostUser = newUr ? newUr : "";
          this.groupUserDto.meetingLevel = 1;
          this.dialogVisible = true;
          this.startSearch();
          break;
        case 2:
          this.dialogVisible2 = true;
          break;
        case 3:
          this.addQuick();
          break;
        default:
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisible2 = false;
      this.dialogVisible3 = false;
      this.groupUserDto = {
        cameraIds: [], //群成员id
        content: "", //音视频聊天 会议内容
        createUser: "", //创建人
        groupName: "", //群名称
        hostUnit: "", //音视频聊天 主持单位
        hostUser: "", //音视频聊天 主持人
        id: "", //指定id（如报警时使用报警事件id）
        meetingLevel: 0, //音视频聊天 会议程度 0 不是会议（普通聊天群） 1 紧急会议 2 预约会议
        startTime: "", //音视频聊天 会议开始事件
        type: 2, //群类型，0，单聊群，1，多人聊天群 2，音视频聊天
        userIds: [], //群成员id
        allUser: [], //所有ID
        sms: false,
      };
      this.groupDto = {
        groupId: "",
        in: true,
      };
      this.userDto = {
        userId: [],
        cameraId: [],
      };
    },
    joinConference(isTrue, formName) {
      //加入会议or退出会议
      if (isTrue) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let groupDto = {
              in: isTrue,
              groupId: this.groupDto.groupId,
              userId: sessionStorage.getItem("userId"),
              type: false,
            };
            this.addOrRemoveMeeting(groupDto, isTrue);
            this.deleted = false;
            this.isNormal = true;
            sessionStorage.setItem("deleted", false);
            this.searchMeetingList(false, 2);
          } else {
            return false;
          }
        });
      } else {
        let groupDto = {
          in: isTrue,
          groupId: this.groupDto.groupId,
          serId: sessionStorage.getItem("userId"),
          type: false,
        };
        this.addOrRemoveMeeting(groupDto, isTrue);
      }
    },
    addOrRemoveMeeting(groupDto, isTrue) {
      this.$http.post(publicAPI.addOrRemoveMeeting, [groupDto]).then((res) => {
        if (res.status == 200) {
          this.$message.success(isTrue ? "加入会议成功" : "退出会议成功");
          if (isTrue) {
            this.$store.commit("setMeetingId", groupDto.id);
            sessionStorage.setItem("meetingId", groupDto.id);
          } else {
            this.SelectGroupId = "";
            this.getListData();
          }
          this.handleClose();
        }
      });
    },

    addMeeting(formName) {
      //添加会议
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let groupUserDto = JSON.parse(JSON.stringify(this.groupUserDto));
          groupUserDto.userIds = this.groupUserDto.userIds.map((item) => {
            return item.id;
          });
          groupUserDto.cameraIds = this.groupUserDto.cameraIds.map((item) => {
            return item.id;
          });
          if (groupUserDto.userIds.length == 0 && groupUserDto.cameraIds == 0) {
            this.$message.error("请添加会议人员");
            return false;
          }
          this.$http.post(publicAPI.createMeeting, groupUserDto).then((res) => {
            if (res.status == 200) {
              this.$message.success("添加会议成功");
              this.handleClose();
              this.isNormal = true;
              this.SelectGroupId = "";
              this.getListData();
            }
          });
        } else {
          return false;
        }
      });
    },
    addUserMeeting() {
      let userDto = JSON.parse(JSON.stringify(this.userDto));
      let groupUserDtoArr = [];
      let userIds = [],
        cameraId = [];
      if (userDto.userId.length) {
        userIds = userDto.userId.map((item) => {
          return item.id;
        });
        userIds.forEach((item) => {
          groupUserDtoArr.push({
            groupId: this.SelectGroupId,
            in: true,
            type: false,
            userId: item,
          });
        });
      }
      if (userDto.cameraId.length) {
        cameraId = userDto.cameraId.map((item) => {
          return item.id;
        });
        cameraId.forEach((item) => {
          groupUserDtoArr.push({
            groupId: this.SelectGroupId,
            in: true,
            type: true,
            userId: item,
          });
        });
      }

      if (groupUserDtoArr.length == 0) {
        this.$message.error("请添加会议人员或者摄像头");
        return false;
      }
      this.$http.post(publicAPI.addOrRemoveMeeting, groupUserDtoArr).then((res) => {
        if (res.status == 200) {
          this.$message.success("加入会议成功");
          this.handleClose();
          this.isNormal = true;
          this.searchMeetingList(this.deleted, 2);
        }
      });
    },
    closable(list, item) {
      list.splice(
        list.findIndex((el) => {
          return el.id === item.id;
        }),
        1
      );
    },
    handleClick(tab) {
      this.activeName = tab.name;
      if (this.activeName == "second") {
        this.startSearch2();
      } else {
        this.startSearch();
      }
    },
    handleClick2(tab) {
      this.activeName2 = tab.name;
      if (this.activeName2 == "second") {
        this.startSearch4();
      } else {
        this.startSearch3();
      }
    },
    resetCallBack() {
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.nameOrPhone = "";
      this.searchParams.isDown = this.switchVal;
      this.startSearch();
    },
    resetCallBack2() {
      this.searchParams2.type = "";
      this.searchParams2.monitorType = "";
      this.searchParams2.search = "";
      this.searchParams2.isDown = this.switchVal2;
      this.searchParams2.page = this.pagination2.page = 1;
      this.startSearch2();
    },
    resetCallBack3() {
      this.searchParams3.page = this.pagination3.page = 1;
      this.searchParams3.nameOrPhone = "";
      this.searchParams3.isDown = this.switchVal3;
      this.startSearch3();
    },
    resetCallBack4() {
      this.searchParams4.type = "";
      this.searchParams4.monitorType = "";
      this.searchParams4.search = "";
      this.searchParams4.isDown = this.switchVal4;
      this.searchParams4.page = this.pagination4.page = 1;
      this.startSearch4();
    },
    setSearchParams(value) {
      if (value) {
        this.pagination.page = value.page;
      }
      this.startSearch();
    },
    setSearchParams2(value) {
      if (value) {
        this.pagination2.page = value.page;
      }
      this.startSearch2();
    },
    setSearchParams3(value) {
      if (value) {
        this.pagination3.page = value.page;
      }
      this.startSearch3();
    },
    setSearchParams4(value) {
      if (value) {
        this.pagination4.page = value.page;
      }
      this.startSearch4();
    },
    startSearch() {
      this.tableLoading = true;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.$http
        .get(userApi.getVisionUserList, {
          params: params,
        })
        .then((res) => {
          this.tableLoading = false;
          if (res.status == 200) {
            res.result.pageList.forEach((item) => {
              item.isAuthName = item.isAuth ? "是" : "否";
              item.userTypeName = this.userTypest(item.userType);
            });
            this.tableTemplateData = res.result.pageList;
            this.pagination.total = res.result.total;
          }
        });
    },
    startSearch2() {
      this.tableLoading2 = true;
      let params = JSON.parse(JSON.stringify(this.searchParams2));
      this.$http
        .get(cameraApi.queryListByPage, {
          params: params,
        })
        .then((res) => {
          this.tableLoading2 = false;
          if (res.status === 200) {
            this.tableTemplateData2 = res.result.pageList;
            this.pagination2.total = res.result.total;
          }
        });
    },
    startSearch3() {
      this.tableLoading3 = true;
      let params = JSON.parse(JSON.stringify(this.searchParams3));
      this.$http
        .get(userApi.getVisionUserList, {
          params: params,
        })
        .then((res) => {
          this.tableLoading3 = false;
          if (res.status == 200) {
            res.result.pageList.forEach((item) => {
              item.isAuthName = item.isAuth ? "是" : "否";
              item.userTypeName = this.userTypest(item.userType);
            });
            this.tableTemplateData3 = res.result.pageList;
            this.pagination3.total = res.result.total;
          }
        });
    },
    startSearch4() {
      this.tableLoading4 = true;
      let params = JSON.parse(JSON.stringify(this.searchParams4));
      this.$http
        .get(cameraApi.queryListByPage, {
          params: params,
        })
        .then((res) => {
          this.tableLoading4 = false;
          if (res.status === 200) {
            this.tableTemplateData4 = res.result.pageList;
            this.pagination4.total = res.result.total;
          }
        });
    },
    userTypest(item) {
      let arr = [];
      item.split(",").forEach((it) => {
        if (it == 0) {
          arr.push("普通用户");
        }
        if (it == 1) {
          arr.push("接警员");
        }
        if (it == 2) {
          arr.push("出警员");
        }
        if (it == 3) {
          arr.push("区域权限");
        }
      });
      return arr.join(",");
    },
    sizeChange(size) {
      this.searchParams.size = this.pagination.size = size;
      this.startSearch();
    },
    changeSwitch(e) {
      this.searchParams.isDown = e;
      this.switchVal = e;
      this.startSearch();
    },
    changeSwitch2(e) {
      this.searchParams2.isDown = e;
      this.switchVal2 = e;
      this.startSearch2();
    },
    changeSwitch3(e) {
      this.searchParams3.isDown = e;
      this.switchVal3 = e;
      this.startSearch3();
    },
    changeSwitch4(e) {
      this.searchParams4.isDown = e;
      this.switchVal4 = e;
      this.startSearch4();
    },
    nodeClick(node) {
      this.searchParams.areaId = node.id;
      this.searchParams.page = this.pagination.page = 1;
      this.startSearch();
    },
    nodeClick2(node) {
      this.searchParams2.areaId = node.id;
      this.searchParams2.page = this.pagination2.page = 1;
      this.startSearch2();
    },
    nodeClick3(node) {
      this.searchParams3.areaId = node.id;
      this.searchParams3.page = this.pagination3.page = 1;
      this.startSearch3();
    },
    nodeClick4(node) {
      this.searchParams4.areaId = node.id;
      this.searchParams4.page = this.pagination4.page = 1;
      this.startSearch4();
    },
    // 当前页
    pageChange(page) {
      this.searchParams.page = this.pagination.page = page;
      this.startSearch();
    },
    sizeChange2(size) {
      this.searchParams2.size = this.pagination2.size = size;
      this.startSearch2();
    },
    sizeChange3(size) {
      this.searchParams3.size = this.pagination3.size = size;
      this.startSearch3();
    },
    sizeChange4(size) {
      this.searchParams4.size = this.pagination4.size = size;
      this.startSearch4();
    },
    // 当前页
    pageChange3(page) {
      this.searchParams3.page = this.pagination3.page = page;
      this.startSearch3();
    },

    // 当前页
    pageChange2(page) {
      this.searchParams2.page = this.pagination2.page = page;
      this.startSearch2();
    },
    // 当前页
    pageChange4(page) {
      this.searchParams4.page = this.pagination4.page = page;
      this.startSearch4();
    },
    copy() {
      let inputElement = document.getElementById("meeting");
      let input = document.getElementById("input");
      input.value = inputElement.innerText; // 这里表示想要复制的内容
      input.select();
      document.execCommand("Copy");
    },
    addUser() {
      //添加群成员
      this.startSearch3();
      this.dialogVisible3 = true;
    },
  },
};
</script>

<style lang="less">
@import "index.less";
.real-time-intercom {
  .real-left {
    // height: calc(100vh - 100px);
  }
  .real-right {
    display: flex;
    flex-direction: column;
    // height: calc(100vh - 100px);
    .real-box {
      height: calc(100% - 54px) !important;
    }
    .no-btn {
      height: 100% !important;
    }
  }

  .flex-content {
    display: flex;
    height: 450px;

    .left {
      margin-right: 10px;
    }

    .right {
      flex: 1;
      display: flex;
	  flex-direction: column;
	  .components-tabel{
		  height: calc(100% - 53px);
	  }
    }
  }

  .null-vision {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    flex: 1;
    .iconkafei {
      font-size: 65px;
    }

    span {
      margin: 10px 0 5px 0;
    }

    .add-vision {
      font-size: 20px;
      padding: 10px 50px;
    }
  }

  //   添加会议
  .add-Meeting {
	height: 90vh;
	display: flex;
	flex-direction: column;
	.el-dialog__body{
		flex: 1;
		overflow-y: scroll;
	}
  }
}
</style>
